import { useCallback, useState } from 'react';

import { DeleteScheduledStreamModalProps } from './types';

export const useDestinationHandlers = ({
  list,
  isPastStream,
  canDeleteFile,
  onDelete
}: Omit<DeleteScheduledStreamModalProps, 'isPending'>) => {
  const defaultIds = isPastStream ? [] : list.map(({ id }) => id);
  const [newDestinationIds, setNewDestinationIds] = useState<string[]>(defaultIds);

  const handleAddDeleteId = useCallback(
    (newId: string) => {
      const newList = new Set(newDestinationIds);

      newList.has(newId) ? newList.delete(newId) : newList.add(newId);

      setNewDestinationIds([...newList]);
    },
    [newDestinationIds]
  );

  const handleDeleteDestinations = useCallback(() => {
    onDelete({ canDeleteFile, destinationIds: newDestinationIds });
  }, [canDeleteFile, onDelete, newDestinationIds]);

  return [handleAddDeleteId, handleDeleteDestinations, newDestinationIds] as const;
};

export const useDeleteStreamFromFolderHandlers = () => {
  const [isChecked, setIsChecked] = useState(false);

  const handleChange = useCallback(() => setIsChecked(prev => !prev), []);

  return [isChecked, handleChange] as const;
};
